import { useQuery } from "@tanstack/react-query";

import { GetAdminLogs } from "@/api/services/admin-logs";
import { IAdminLogsParams } from "@/api/types/admin-logs";

export function useAdminLogs(params?: Partial<IAdminLogsParams>) {
    return useQuery({
        queryKey: ["admin-logs", params],
        queryFn: () => GetAdminLogs(params || {}),
    });
}
